import React, { ReactNode } from "react";
import './styles.css';
import { Bounce, ToastContainer } from "react-toastify";
import NavigationBar from "../navigationBar";

interface DrawerPageLayoutProps {
    children: ReactNode | ReactNode[],
}

export default function DrawerPageLayout(props: DrawerPageLayoutProps) {

    const [height, setHeight] = React.useState(window.innerHeight);

    React.useEffect(() => {
        window.addEventListener('resize', () => {
            setHeight(window.innerHeight);
        })
    }, [])

    return (
        <div className="drawer-screen"
        style={{
            height: height
        }}
        >
            <NavigationBar />
            <ToastContainer
                position="bottom-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
            <div className="drawer-screen-content"

            >
                {props.children && props.children}
            </div>
        </div>

    )
}